export default function updateObjectByPath(object, newValue, path) {
  const stack = path;

  while (stack.length > 1) {
    object = object[stack.shift()];
  }

  object[stack.shift()] = newValue;
}
